// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_main_container{
    background-color: #012D01;
    height: 336px;
    display: flex;
    justify-content: space-between;
    padding: 30px 50px;
    color: #FFFFFF !important ;
}

a{
    text-decoration: none;
}


.footer_location{
    display: flex;
    justify-content: space-between;
    padding: 20px 0  10px 0;
    width: 297px;
    cursor: pointer;
}

.footer_location p{
    font-weight: 400;
    font-size: 16px;
    line-height: 24.46px;
}

.footer_location, .footer_location a {
    text-decoration: none;
    color: rgba(255, 255, 255, 0.5);
}

.footer_location_change, .footer_location a.active
{
    color: #FFFFFF !important;
}


.footerHr{
    width: 301px;
    border: 1px solid #5CBF14;
}

.footer_address_container p{
    width: 352px;
    font-weight: 400;
    font-size: 14px;
    line-height: 21.41px;
    padding: 10px 0;
    color: #FFFFFF !important;
}

.footer_contact{
    font-weight: 400;
    font-size: 14px;
    line-height: 21.41px;
    /* height: 50px; */
    padding: 10px 0;
    
}

.footer_contact p{
    color: #FFFFFF !important;
    width: 220px;
}

.footer_column2{
    display: flex;
    justify-content: space-between;
    gap: 90px;
}

.vatebra_info_container{
    display: flex;
    gap: 90px;
}

.footer_column2_part1{
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.footer_column2_part1h5{
    font-weight: 700;
    font-size: 16px;
    line-height: 24.46px;
}

.footer_column2_part1p{
    font-weight: 400;
    font-size: 16px;
    line-height: 24.46px;
    color: rgba(255, 255, 255, 0.8);
}
.footer_column2_part1p a{
    text-decoration: none;
    color: #FFFFFF;
}

.footer_column2_part1p a:hover{
    color: #5CBF14;
}

.footer_column2_part3{
    display: flex;
    flex-direction: column;
    gap: 50px;
}

.footersocials_container{
    display: flex;
    gap: 10px;
}

.contactus_footer_btn{
    display: flex;
    justify-content: center;
    align-items: center ;
    color: #FFFFFF !important;
    background-color: #5CBF14;
    border-radius: 25px;
    padding: 12px 0 4px 0;
    gap: 15px;
    width: 222px;
}

.contactus_footer_btn:hover{
    background-color: #000000;
}

.contactus_footer_btn_p{
    font-size: 14px !important;
    font-weight: 400;
    line-height: 21px;
    color: #FFFFFF !important;
}


.contactus_footer_btn_icon{
    width: 21px;
    height: 21px;
    margin-bottom: 10px;
}


@media screen and (max-width: 1050px){

    .footer_main_container{
        gap: 50px;
    }
    
    .vatebra_info_container{
        display: flex;
        gap: 50px;
    }

    .footer_location{
        display: flex;
        justify-content: space-between;
        padding: 20px 0  10px 0;
        width: 237px;
    }
    
    
    .footerHr{
        width: 260px;
    }
    
    .footer_address_container p{
        width: 300px;
        font-weight: 400;
        font-size: 14px;
        line-height: 21.41px;
        padding: 10px 0;
    }
    
    
    .footer_column2{
        display: flex;
        justify-content: space-between;
        gap: 50px;
    }
    
    .footer_column2_part3_isoaward img{
        width: 350px ;
    }
    
}


@media screen and (max-width: 900px){
    .footer_main_container{
        padding: 30px 40px;
        gap: 30px;
    }

    .vatebra_info_container{
        display: flex;
        gap: 30px;
    }
    
    .footer_location{
        width: 200px;
    }
    
    .footer_location p{
        font-size: 13px;          
    }
    
    
    .footerHr{
        width: 220px;
    }
    
    .footer_address_container p{
        width: 250px;
        font-size: 12px;
    }
    
    .footer_contact{
        font-size: 12px;
    }
    
    .footer_column2{
        gap: 30px;
    }
    
    .footer_column2_part1h5{
        font-size: 14px;
    }
    
    .footer_column2_part1p{
        font-size: 13px;
    }
    
    .footer_column2_part3_isoaward img{
        width: 270px ;
    }
}

@media screen and (max-width: 500px){
    .footer_main_container{
        background-color: #012D01;
        height: auto;
        display: flex;
        padding: 20px 20px;
        flex-direction: column;
    }

    
    .footer_location{
        display: flex;
        justify-content: space-between;
        padding: 20px 0  10px 0;
        width: 297px;
    }
    
    .footer_location p{
        font-weight: 400;
        font-size: 16px;
        line-height: 24.46px;
        
    }
    
    .footer_location_common{
        color: rgba(255, 255, 255, 0.5);
    }
    
    .footerHr{
        width: 301px;
        border: 1px solid #5CBF14;
    }
    
    .footer_address_container p{
        width: 350px;
        font-weight: 400;
        font-size: 14px;
        line-height: 21.41px;
        padding: 10px 0;
    }
    
    .footer_contact{
        font-weight: 400;
        font-size: 14px;
        line-height: 21.41px;
        /* height: 50px; */
        padding: 10px 0;
    }
    
    .footer_column2{
        display: flex;
        flex-direction: column;
        padding-bottom: 100px;
    }
    
    .footer_column2_part1{
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    
    .footer_column2_part1h5{
        font-weight: 700;
        font-size: 16px;
        line-height: 24.46px;
    }
    
    .footer_column2_part1p{
        font-weight: 400;
        font-size: 16px;
        line-height: 24.46px;
        color: rgba(255, 255, 255, 0.8);
    }
    
    .footer_column2_part3{
        display: flex;
        flex-direction: column;
    }
    
    .footersocials_container{
        display: flex;
        gap: 10px;
    }
}


@media screen and (max-width: 380px){
    
    .footer_location{
        width: 250px;
    }
    
    .footer_location p{
        font-size: 15px;
    }
    
    
    .footerHr{
        width: 270px;
    }
    
    .footer_address_container p{
        width: 300px;
        font-size: 13px;
    }
    
    .footer_contact{
        font-size: 13px;
    }
    
    
    .footer_column2_part1h5{
        font-size: 15px;
    }
    
    .footer_column2_part1p{
        font-size: 14px;
    }

    .footer_column2_part3_isoaward img{
        width: 250px ;
    }
    
    .footersocials_container img{
        width: 19px;
    }
}

@media screen and (max-width: 330px){
    
    .footer_location{
        width: 230px;
    }
    
    .footer_location p{
        font-size: 13px;
    }
    
    
    .footerHr{
        width: 250px;
    }
    
    .footer_address_container p{
        width: 280px;
        font-size: 12px;
    }
    
    .footer_contact{
        font-size: 12px;
    }
    
}


`, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;;IAEI,yBAAyB;AAC7B;;;AAGA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;;AAEnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,+BAA+B;AACnC;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;;IAEI;QACI,SAAS;IACb;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,uBAAuB;QACvB,YAAY;IAChB;;;IAGA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,eAAe;IACnB;;;IAGA;QACI,aAAa;QACb,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;AAEJ;;;AAGA;IACI;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,sBAAsB;IAC1B;;;IAGA;QACI,aAAa;QACb,8BAA8B;QAC9B,uBAAuB;QACvB,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;;IAExB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,YAAY;QACZ,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,qBAAqB;IACzB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,+BAA+B;IACnC;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,SAAS;IACb;AACJ;;;AAGA;;IAEI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;;IAEI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ","sourcesContent":[".footer_main_container{\n    background-color: #012D01;\n    height: 336px;\n    display: flex;\n    justify-content: space-between;\n    padding: 30px 50px;\n    color: #FFFFFF !important ;\n}\n\na{\n    text-decoration: none;\n}\n\n\n.footer_location{\n    display: flex;\n    justify-content: space-between;\n    padding: 20px 0  10px 0;\n    width: 297px;\n    cursor: pointer;\n}\n\n.footer_location p{\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24.46px;\n}\n\n.footer_location, .footer_location a {\n    text-decoration: none;\n    color: rgba(255, 255, 255, 0.5);\n}\n\n.footer_location_change, .footer_location a.active\n{\n    color: #FFFFFF !important;\n}\n\n\n.footerHr{\n    width: 301px;\n    border: 1px solid #5CBF14;\n}\n\n.footer_address_container p{\n    width: 352px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 21.41px;\n    padding: 10px 0;\n    color: #FFFFFF !important;\n}\n\n.footer_contact{\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 21.41px;\n    /* height: 50px; */\n    padding: 10px 0;\n    \n}\n\n.footer_contact p{\n    color: #FFFFFF !important;\n    width: 220px;\n}\n\n.footer_column2{\n    display: flex;\n    justify-content: space-between;\n    gap: 90px;\n}\n\n.vatebra_info_container{\n    display: flex;\n    gap: 90px;\n}\n\n.footer_column2_part1{\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.footer_column2_part1h5{\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24.46px;\n}\n\n.footer_column2_part1p{\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24.46px;\n    color: rgba(255, 255, 255, 0.8);\n}\n.footer_column2_part1p a{\n    text-decoration: none;\n    color: #FFFFFF;\n}\n\n.footer_column2_part1p a:hover{\n    color: #5CBF14;\n}\n\n.footer_column2_part3{\n    display: flex;\n    flex-direction: column;\n    gap: 50px;\n}\n\n.footersocials_container{\n    display: flex;\n    gap: 10px;\n}\n\n.contactus_footer_btn{\n    display: flex;\n    justify-content: center;\n    align-items: center ;\n    color: #FFFFFF !important;\n    background-color: #5CBF14;\n    border-radius: 25px;\n    padding: 12px 0 4px 0;\n    gap: 15px;\n    width: 222px;\n}\n\n.contactus_footer_btn:hover{\n    background-color: #000000;\n}\n\n.contactus_footer_btn_p{\n    font-size: 14px !important;\n    font-weight: 400;\n    line-height: 21px;\n    color: #FFFFFF !important;\n}\n\n\n.contactus_footer_btn_icon{\n    width: 21px;\n    height: 21px;\n    margin-bottom: 10px;\n}\n\n\n@media screen and (max-width: 1050px){\n\n    .footer_main_container{\n        gap: 50px;\n    }\n    \n    .vatebra_info_container{\n        display: flex;\n        gap: 50px;\n    }\n\n    .footer_location{\n        display: flex;\n        justify-content: space-between;\n        padding: 20px 0  10px 0;\n        width: 237px;\n    }\n    \n    \n    .footerHr{\n        width: 260px;\n    }\n    \n    .footer_address_container p{\n        width: 300px;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 21.41px;\n        padding: 10px 0;\n    }\n    \n    \n    .footer_column2{\n        display: flex;\n        justify-content: space-between;\n        gap: 50px;\n    }\n    \n    .footer_column2_part3_isoaward img{\n        width: 350px ;\n    }\n    \n}\n\n\n@media screen and (max-width: 900px){\n    .footer_main_container{\n        padding: 30px 40px;\n        gap: 30px;\n    }\n\n    .vatebra_info_container{\n        display: flex;\n        gap: 30px;\n    }\n    \n    .footer_location{\n        width: 200px;\n    }\n    \n    .footer_location p{\n        font-size: 13px;          \n    }\n    \n    \n    .footerHr{\n        width: 220px;\n    }\n    \n    .footer_address_container p{\n        width: 250px;\n        font-size: 12px;\n    }\n    \n    .footer_contact{\n        font-size: 12px;\n    }\n    \n    .footer_column2{\n        gap: 30px;\n    }\n    \n    .footer_column2_part1h5{\n        font-size: 14px;\n    }\n    \n    .footer_column2_part1p{\n        font-size: 13px;\n    }\n    \n    .footer_column2_part3_isoaward img{\n        width: 270px ;\n    }\n}\n\n@media screen and (max-width: 500px){\n    .footer_main_container{\n        background-color: #012D01;\n        height: auto;\n        display: flex;\n        padding: 20px 20px;\n        flex-direction: column;\n    }\n\n    \n    .footer_location{\n        display: flex;\n        justify-content: space-between;\n        padding: 20px 0  10px 0;\n        width: 297px;\n    }\n    \n    .footer_location p{\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24.46px;\n        \n    }\n    \n    .footer_location_common{\n        color: rgba(255, 255, 255, 0.5);\n    }\n    \n    .footerHr{\n        width: 301px;\n        border: 1px solid #5CBF14;\n    }\n    \n    .footer_address_container p{\n        width: 350px;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 21.41px;\n        padding: 10px 0;\n    }\n    \n    .footer_contact{\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 21.41px;\n        /* height: 50px; */\n        padding: 10px 0;\n    }\n    \n    .footer_column2{\n        display: flex;\n        flex-direction: column;\n        padding-bottom: 100px;\n    }\n    \n    .footer_column2_part1{\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n    }\n    \n    .footer_column2_part1h5{\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 24.46px;\n    }\n    \n    .footer_column2_part1p{\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24.46px;\n        color: rgba(255, 255, 255, 0.8);\n    }\n    \n    .footer_column2_part3{\n        display: flex;\n        flex-direction: column;\n    }\n    \n    .footersocials_container{\n        display: flex;\n        gap: 10px;\n    }\n}\n\n\n@media screen and (max-width: 380px){\n    \n    .footer_location{\n        width: 250px;\n    }\n    \n    .footer_location p{\n        font-size: 15px;\n    }\n    \n    \n    .footerHr{\n        width: 270px;\n    }\n    \n    .footer_address_container p{\n        width: 300px;\n        font-size: 13px;\n    }\n    \n    .footer_contact{\n        font-size: 13px;\n    }\n    \n    \n    .footer_column2_part1h5{\n        font-size: 15px;\n    }\n    \n    .footer_column2_part1p{\n        font-size: 14px;\n    }\n\n    .footer_column2_part3_isoaward img{\n        width: 250px ;\n    }\n    \n    .footersocials_container img{\n        width: 19px;\n    }\n}\n\n@media screen and (max-width: 330px){\n    \n    .footer_location{\n        width: 230px;\n    }\n    \n    .footer_location p{\n        font-size: 13px;\n    }\n    \n    \n    .footerHr{\n        width: 250px;\n    }\n    \n    .footer_address_container p{\n        width: 280px;\n        font-size: 12px;\n    }\n    \n    .footer_contact{\n        font-size: 12px;\n    }\n    \n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
